import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=b36906c2&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/journal_detail.css?vue&type=style&index=0&id=b36906c2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36906c2",
  null
  
)

export default component.exports